import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/case_studies/obc/01/thumbnail.jpg'

const paperInfo = {
  paperName: 'commmune導入事例_株式会社オービックビジネスコンサルタント（OBC）様',
  enPaperName: 'caseStudy-OBC',
  thumbnail: thumbnail,
  feature1: 'パートナー様同士の繋がりによる情報共有の効果',
  feature2: '多目的なポータルとしての活用方法',
  feature3: '双方向コミュニケーションのメリット',
  description:
    '基幹業務システムのメーカーとして、企業向けのソリューション開発・販売・保守サービスを提供しているOBC様の事例です。販売パートナー様（代理店）におけるコミュニティの活用方法が理解できる資料です。',
  formSrc: 'https://go.commmune.jp/l/915341/2022-01-19/bp4v3',
  type: 'pardot'
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
